export default __webpack_public_path__ + "static/e-spres-oh_logo-ec8b66443367f33db6ceacaa909be810.svg";